<app-base-side-panel-modal>
  <ng-template #header>
    <div class="flex justify-start items-center gap-3">
      <svg-icon class="w-8 h-8 svg-dark" [src]="'edit'"></svg-icon>
      <div class="text-navy-90">
        {{ buildTranslationKey('subprocessor.edit') | translate }}
      </div>
    </div>
  </ng-template>

  <ng-template #content>
    <div #contentContainer class="flex flex-col gap-5 h-full overflow-hidden">
      <div #nameContainer class="flex justify-between items-center">
        <div class="flex items-center justify-center gap-2">
          <svg-icon class="w-12.5 h-12.5" [src]="serviceIcon"></svg-icon>
          <div class="text-navy-90 font-bold text-3xl">
            {{ subprocessor.name }}
          </div>
        </div>
      </div>

      <div
        class="flex flex-col relative gap-5"
        [style.max-height.px]="formMaxHeight"
        [class.thin-show-text]="form?.controls['isVisible'].value === false">
        <dynamic-form-outlet [dynamicFormGroup]="form"></dynamic-form-outlet>
      </div>
    </div>
  </ng-template>

  <ng-template #footer>
    <div class="flex gap-2">
      <app-new-button
        class="checkmark-button"
        [saveButtonSizeDuringLoading]="true"
        [type]="'primary'"
        [svgIconPath]="'checkmark'"
        [size]="'responsive'"
        [loading]="sendingRequestBtnLoader$ | async"
        [disabled]="form?.invalid || !wasFormValueChanged"
        (click)="saveBtnClick()"
      >
        {{ buildTranslationKey('saveChangesBtn') | translate }}
      </app-new-button>

      <app-new-button [size]="'responsive'" [type]="'secondary'" (click)="closePanel()">
        {{ buildTranslationKey('cancel') | translate }}
      </app-new-button>
    </div>
  </ng-template>
</app-base-side-panel-modal>
